import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="13.75" height="15" viewBox="0 0 13.75 15"><path d="M3.75-15V0h12.5V-5.625H15V-1.25H5v-12.5H15v4.375h1.25V-15Zm7.188,4.375-2.7,2.676-.43.449.43.449,2.7,2.676.879-.879L10.2-6.875h7.3v-1.25H10.2l1.621-1.621Z" transform="translate(-3.75 15)"/></svg>

  )
